import * as angular from "angular";
import {IController} from "angular";

export class cancellationReasonsTableCtrl implements IController {

  cancellationReasons: any;
  onUpdateCancellationReason: Function;
  onDeleteCancellationReason: Function;

  /* @ngInject */
  constructor() {}

  $onInit() {
  }
}

angular
  .module('bringoz.admin.cancellation-reasons')
  .component('cancellationReasonsTable', {
    bindings: {
      cancellationReasons: '<',
      onUpdateCancellationReason: '&',
      onDeleteCancellationReason: '&'
    },
    template: require('./cancellation-reasons-table.html').default,
    controller: cancellationReasonsTableCtrl
  });
